    <div class="modal-header">
        <h4 class="modal-title">Kunde Nr: {{kunde.glkundenr}} </h4>
        <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
    </div>

    <div class="modal-body">
        <div class="table__viewport">
            <table class="table table-hover table-striped table-sm table-frame__body" >
                <thead class="fixed-top position-fixed position-sticky">
                    <tr>
                        <th>Faktura</th>
                        <th class="text-nowrap text-end">Beløb</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let faktura of statistikIgangvaerendeKundeFaktura;">
                        <td class="link-td" (click)="onInvoice(faktura.fnr, kunde.kid)">{{ faktura.fakturaNr }}</td>
                        <td class="text-end">{{ faktura.beloeb | currency:'DKK':'':'1.2-2':'da' }}</td>
                    </tr>
                </tbody>

                <tfoot class="fixed-bottom position-fixed position-sticky">
                    <tr>
                        <th>Total</th>
                        <th class="text-end">{{GetTotalBeloeb() | currency:'DKK':'':'1.2-2':'da'}}</th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
